import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ApplicationStore, ApplicationStoreType } from '../../../../core/store/application.store';
import { Popup, PopupType } from '../popup';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { ConfirmationPopupModel } from '../confirmation-popup/confirmation-popup.model';

@Component({
    selector: 'juyo-popup-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ConfirmationPopupComponent],
    template: `
        @for (popup of applicationStore.popups(); track popup.id) {
            @switch (popup.type) {
                @case (PopupType.Confirmation) {
                    <juyo-confirmation-popup [model]="asConfirmation(popup)"></juyo-confirmation-popup>
                }
            }
        }
    `,
})
export class PopupContainerComponent {
    protected readonly applicationStore: ApplicationStoreType = inject(ApplicationStore);
    protected readonly PopupType = PopupType;

    protected asConfirmation(popup: Popup): ConfirmationPopupModel {
        return popup as ConfirmationPopupModel;
    }
}
